
import './App.css';
import ProcessForm from './pages/processform';
import ReferralDetails from './pages/referraldetails';
import ReferralProceed from './pages/referralproceed';
import WhoAreYou from './pages/whoareyou';
import Resources from './pages/resources';
import ReferrerLogin from './pages/referrerlogin';
import ReferrerRegister from './pages/referrerregister';
import ScreenProcess from './pages/screenprocess';
import UpdateAccount from './pages/updateaccount';
import ReferralPatients from './pages/referralpatients';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import AuthProvider from "./contexts/AuthContext";
import {store} from "./services/store";
import ReferralDefault from './pages/referraldefault';

let persistor = persistStore(store);

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                {/* <Route path="/validateotp/:id" element={<ValidateOtp />} />
                <Route path="/downloadform/:id" element={<DownloadForm />} /> */}
                <Route path="/processform/:orgCode/:id" element={<ProcessForm />} />
                <Route path="/details/:orgCode/:referralId" element={<ReferralDetails />} />
                <Route path="/information/:orgCode" element={<ReferralProceed />} />
                <Route path="/whoareyou/:orgCode" element={<WhoAreYou />} />
                <Route path="/resources/:orgCode" element={<Resources />} />
                <Route path="/login/:orgCode" element={<ReferrerLogin />} />
                <Route path="/register/:orgCode" element={<ReferrerRegister />} />
                <Route path="/screenprocess/:orgCode" element={<ScreenProcess />} />
                <Route path="/updateaccount/:orgCode" element={<UpdateAccount />} />
                <Route path="/patients/:orgCode" element={<ReferralPatients />} />
                {/* <Route path="/:orgCode" element={<SplashPage />} /> */}
                <Route path="/" element={<ReferralDefault />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
